import { groupBy } from 'lodash';
import axios from 'axios';
import { types, flow, Instance } from 'mobx-state-tree';

import * as ResourcesAPI from 'src/services/resources';

export const BoardModel = types.model('BoardModel', {
  id: types.identifierNumber,
  name: types.maybeNull(types.string),
  logo: types.frozen({
    url: types.string,
    thumb: {
      url: types.string
    }
  }),
  country: types.maybeNull(types.string),
  sign_up_and_post_url: types.maybeNull(types.string),
  sign_up_url: types.maybeNull(types.string),
  recover_pass_url: types.maybeNull(types.string),
  skip_auth: types.maybeNull(types.boolean),
  login: types.maybeNull(types.string),
  pass: types.maybeNull(types.string),
  signup_and_post: types.maybeNull(types.boolean),
  job_board_id: types.maybeNull(types.number)
});

export const BoardsModel = types
  .model({
    boardsIsFetching: 0,
    boards: types.array(BoardModel)
  })
  .actions(self => {
    const CancelToken = axios.CancelToken;
    let source = CancelToken.source();

    return {
      abort: function() {
        source.cancel('Operation canceled by the user.');
        source = CancelToken.source();
      },
      getBoards: flow(function*({ jobId }) {
        self.boardsIsFetching = self.boardsIsFetching + 1;
        try {
          self.boards = yield ResourcesAPI.getBoards({ jobId }, { cancelToken: source.token });
        } finally {
          self.boardsIsFetching = self.boardsIsFetching - 1;
        }
      })
    };
  })
  .views(self => ({
    get boardsByCountry() {
      return groupBy(self.boards, 'country');
    }
  }));

export type IBoardsModel = Instance<typeof BoardsModel>;
export type IBoardModel = Instance<typeof BoardModel>;
